import { render } from "./PlaidLink.vue?vue&type=template&id=3a6666b5"
import script from "./PlaidLink.vue?vue&type=script&lang=js"
export * from "./PlaidLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__